import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LandingPage } from "./components/LandingPage";
import { SessionView } from "./components/SessionView";
import { RetroProvider, useRetro } from "./context/RetroContext";

const theme = createTheme({
	palette: {
		primary: {
			main: "#1976d2",
		},
		secondary: {
			main: "#dc004e",
		},
	},
	typography: {
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: "none",
				},
			},
		},
	},
});

function AppContent() {
	const { state } = useRetro();

	return (
		<>
			<CssBaseline />
			{state.session ? <SessionView /> : <LandingPage />}
		</>
	);
}

function App() {
	return (
		<ThemeProvider theme={theme}>
			<RetroProvider>
				<AppContent />
			</RetroProvider>
		</ThemeProvider>
	);
}

export default App;
